/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { EntityVersion, ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { ContactListItemDto } from '../../contacts';
import { JobStageListItemDto } from '../../job-stages';
import { UserListItemDto } from '../../users';
import { ContractType } from '../job.dto';
import { SalesFolderStatus } from '../../leads';

export const JobFinanceType = createEnum('JOB_FINANCE_TYPE', {
  Unknown: 0,
  Cash: 1,
  Morgage: 2,
  Escrow: 3,
});

export type JobFinanceType = EnumSet<typeof JobFinanceType>;

export type FinanceCompany = {
  active: boolean;
  email: string;
  id: ID;
  name: string;
  phones: string;
  version: EntityVersion;
};

export type JobGeneralTabInfoDto = WithVersion<{
  id: ID;
  siteName: string;
  siteLotNumber: string;
  siteBlockNumber: string;
  siteStreet: string;
  siteStreetNumber: string;
  siteSuburb: string;
  sitePostcode: string;
  siteCity: string;
  siteState: string;
  siteMapReference: string;
  baseDesignName: string;
  escrowAllowed: boolean;
  isSupervisorActive: boolean;
  isJobAdminActive: boolean;
  housePlanCode: string;
  housePlanName: string;
  contractType: ContractType;
  county: ContactListItemDto;
  financeType: JobFinanceType;
  financeCompany: FinanceCompany;
  salespersonName: string;
  referredBy: any;
  referredByDetails: string;
  colorConsultantName: string;
  estimator: UserListItemDto;
  supervisor: UserListItemDto;
  jobAdmin: UserListItemDto;
  warrantyMonths: number;
  stage: JobStageListItemDto;
  jobStages: JobStageListItemDto[];
  memo: string;
  salesFolderId: ID;
  salesFolderName: ID;
  salesFolderAddedDate: ID;
  salesFolderStatus: SalesFolderStatus;
  contactId?: ID;
}>;
